import { render, staticRenderFns } from "./OperationLogs.vue?vue&type=template&id=c54c7e34&"
import script from "./OperationLogs.vue?vue&type=script&lang=js&"
export * from "./OperationLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports